import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MinuteRequestDetailRealTimeDTO, OwnersMinuteRequest } from '../../minutes/interface/minute-detail';
import { MinuteRequestService } from '../../minutes/service/minute-request.service';
import { Observable } from 'rxjs';
import { UpdateAvalMinute } from '../../minutes/interface/minute-request.interface';
import { ActivatedRoute, Params } from '@angular/router';
import { faCircleMinus, faCircleCheck, faCircleXmark } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-minutes-owners',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './minutes-owners.component.html',
  styleUrls: ['./minutes-owners.component.scss'],
})
export class MinutesOwnersComponent {
  @Input() minuteOwnersRequest: OwnersMinuteRequest[] | undefined;
  @Input() minuteRequestRealTime: MinuteRequestDetailRealTimeDTO | undefined;
  @Input() forMinute: boolean = false;
  listOwners: string[] = [];
  idMinute: number;
  spinner: boolean = false;

  public dataSourceOwners!: MatTableDataSource<OwnersMinuteRequest>;
  displayedColumnsOwners: string[] = [
    'fullRut',
    'name',
    'lastName',
    'participation',
    'civilState',
    'age',
    'aval',
    'rl',
  ];

  constructor(private minuteRequestService: MinuteRequestService,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    if (this.forMinute) {
      this.displayedColumnsOwners.push('dicom');
      this.displayedColumnsOwners.push('dicomReporter');
    }
    this.route.queryParams.subscribe((params: Params) => {
      const id = params['id'] | 0;
      this.idMinute = id
    });

  }

  ngOnChanges() {
    this.setDataSource(this.minuteOwnersRequest);
  }

  private setDataSource(dataSource: Array<OwnersMinuteRequest> | undefined) {


    this.dataSourceOwners = new MatTableDataSource<OwnersMinuteRequest>(dataSource);
    //console.log("Cantidad de data:" + this.dataSourceOwners.data.length);
  }

  getReportUrl(rut: string) {
    var rutformat = rut.split('.').join('');
    var parametros =
      '{"Token":"IngeInternalApiKey55","Rut":"' + rutformat + '"}';
    var base64Datos = window.btoa(parametros);
    return 'https://scoringreport.inge.cl/api/Equifax/HtmlEncodedReport/' + base64Datos;
  }

  public icons = {
    faCircleMinus, faCircleCheck, faCircleXmark
  };

  public showTd(fullRut: string): boolean {
    return this.listOwners.includes(fullRut)
  }

  public toggleDebtorResolutionChange(event: any, fullRut: string, avalState: boolean) {
    // this.spinner = true;
    this.listOwners.push(fullRut)
    avalState = !avalState;
    const request: UpdateAvalMinute = {
      aval: avalState,
      avalOwnerId: fullRut,
      minuteRequestId: this.idMinute
    }

    let updateDebtorResolution$: Observable<UpdateAvalMinute> = new Observable<UpdateAvalMinute>;
    switch (avalState) {
      case false:
        updateDebtorResolution$ = this.minuteRequestService.updateMinute(request);
        break;
      case true:
        updateDebtorResolution$ = this.minuteRequestService.updateMinute(request);
        break;
      case null:
        null
        break;
    }
    updateDebtorResolution$.subscribe({
      complete: () => {
        this.listOwners = this.listOwners.filter(e => e !== fullRut)
      }
    });
  }
}
